import DeviceInfoServices from 'services/DeviceInfoServices';

const mobileBaseURL = 'dfdmobile:/';

export const MOBILE_PLATFORM_URL = DeviceInfoServices.isAndroid
  ? `${mobileBaseURL}/app`
  : mobileBaseURL;
